var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Table',{staticClass:"requestTable",attrs:{"columns":_vm.tblColumns,"data":_vm.tblData,"size":"small","loading":_vm.isLoading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }